// Dots for the before/after slider on the retinol guide landing page.
// The track is a plain scroll-snap flex row, so swipe and keyboard already
// work with no JS at all — this only adds the dots and keeps them in sync.
// If the script fails to load the slider is still fully usable.
(function () {
  function setup(slider) {
    var track = slider.querySelector('.rg-slider__track');
    var dots = slider.querySelectorAll('.rg-slider__dot');
    if (!track || !dots.length) return;

    var slides = track.querySelectorAll('.rg-slider__slide');

    function current() {
      // Nearest slide to the left edge of the viewport, which is what
      // scroll-snap: start has actually settled on.
      var best = 0;
      var bestGap = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var gap = Math.abs(slides[i].offsetLeft - track.scrollLeft);
        if (gap < bestGap) {
          bestGap = gap;
          best = i;
        }
      }
      return best;
    }

    function sync() {
      var active = current();
      for (var i = 0; i < dots.length; i++) {
        dots[i].setAttribute('aria-current', i === active ? 'true' : 'false');
      }
    }

    for (var i = 0; i < dots.length; i++) {
      (function (index) {
        dots[index].addEventListener('click', function () {
          if (slides[index]) track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
        });
      })(i);
    }

    var queued = false;
    track.addEventListener(
      'scroll',
      function () {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(function () {
          queued = false;
          sync();
        });
      },
      { passive: true }
    );

    sync();
  }

  function init() {
    document.querySelectorAll('.rg-slider').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Section re-renders in the theme editor drop a fresh, unwired slider in.
  document.addEventListener('shopify:section:load', init);
})();
